module.exports = __webpack_public_path__ + "img/full4-min.0e8d7c73.png";